module.exports = __webpack_public_path__ + "static/media/IMG_20171125_164440.055ec4c9.jpg";